import type { PlatformUser } from '@/types/api'

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  SUB_ACCOUNT: 'sub_account'
} as const

export function isSuperAdmin(user: PlatformUser | null | undefined): boolean {
  return user?.role === USER_ROLES.SUPER_ADMIN
}
